/* GOLDSQUARE - hero product carousel

   Coverflow behaviour ported from the supplied PhoneCarousel: one
   centred active item, neighbours scaled back and dimmed, drag,
   arrows, dots, keyboard, optional autoplay.

   ==== WHY CLICKS WERE DEAD ON THE SIDE PACKS ====
   Every .fh-car__slide is position:absolute; inset:0 - each one spans
   the WHOLE viewport and merely paints its card at an offset. The
   centre slide carries the highest z-index, so its transparent box sat
   over the entire area and swallowed every click. Only the card inside
   it could ever be reached; clicking a side pack hit the centre
   slide's empty region and nothing happened.

   Fix: the slide boxes never take pointer events at all. Each card
   does. Hit testing then falls through the empty areas and lands on
   whichever card is actually under the cursor, with z-index deciding
   overlaps. This is set from JS rather than CSS because layout() also
   writes inline styles here, and an inline value would win over a
   stylesheet rule.

   ==== EVERY CARD NAVIGATES ====
   An earlier version made a click on a side pack centre it instead of
   opening it, on the theory that you should not be sent somewhere you
   were only pointing at. In practice clicking a product and watching it
   slide sideways reads as broken. All three now go straight to their
   product page; arrows, dots and drag are what move the carousel.

   ==== NO POINTER CAPTURE ====
   setPointerCapture retargets the compatibility mouse events, click
   included, to the capturing element - which is another way to lose
   the anchor. Tracking on window instead means a drag that ends
   outside the viewport still resolves, without touching click routing.

   ==== CIRCULAR DISTANCE ====
   Offsetting each slide by (i - index) leaves the first slide with
   nothing to its left - the deck sits lopsided in a centred hero. The
   short way round keeps something on both sides and joins the ends.

   ==== SPREAD IS AN ATTRIBUTE ====
   Each slide spans the viewport, so translateX percentages are
   relative to the whole column, not the card. Too large a value throws
   the neighbours out of view entirely, so it is tunable from markup.
*/

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.getAttribute('data-car-ready') === '1') return;
    root.setAttribute('data-car-ready', '1');

    var slides = [].slice.call(root.querySelectorAll('[data-car-slide]'));
    if (!slides.length) return;

    var viewport = root.querySelector('[data-car-viewport]');
    var prevBtn  = root.querySelector('[data-car-prev]');
    var nextBtn  = root.querySelector('[data-car-next]');
    var dotsWrap = root.querySelector('[data-car-dots]');
    var live     = root.querySelector('[data-car-live]');

    var n = slides.length;
    var index = 0;
    var dots = [];
    var spread = parseFloat(root.getAttribute('data-car-spread')) || 34;

    var startX = 0, down = false, dragged = false;

    function dist(i) {
      var d = i - index;
      if (d >  n / 2) d -= n;
      if (d < -n / 2) d += n;
      return d;
    }

    function layout() {
      for (var i = 0; i < n; i++) {
        var s = slides[i];
        var link = s.querySelector('a');
        var d = dist(i);
        var a = Math.abs(d);

        /* The slide box spans the viewport and would block the cards
           beneath it. Only the card is ever a hit target. */
        s.style.pointerEvents = 'none';

        if (a > 2) {
          s.style.opacity = '0';
          s.style.transform = 'translateX(' + (d * (spread + 8)) + '%) scale(.55)';
          s.style.zIndex = '0';
          s.setAttribute('aria-hidden', 'true');
          if (link) { link.style.pointerEvents = 'none'; link.tabIndex = -1; }
          continue;
        }

        s.style.transform =
          'translateX(' + (d * spread) + '%) scale(' + (1 - a * 0.15) + ') rotate(' + (d * -5) + 'deg)';
        s.style.opacity = a === 0 ? '1' : '0.5';
        s.style.zIndex = String(10 - a);
        s.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
        if (link) { link.style.pointerEvents = 'auto'; link.tabIndex = 0; }
      }

      for (var k = 0; k < dots.length; k++) {
        var on = k === index;
        dots[k].classList.toggle('is-active', on);
        dots[k].setAttribute('aria-selected', on ? 'true' : 'false');
        dots[k].tabIndex = on ? 0 : -1;
      }

      if (live) {
        var label = slides[index].getAttribute('data-car-label') || '';
        live.textContent = label + ' - ' + (index + 1) + ' of ' + n;
      }
    }

    function go(i) {
      index = ((i % n) + n) % n;
      layout();
    }

    /* --- autoplay (declared before use by the controls below) --- */
    var delay = parseInt(root.getAttribute('data-car-autoplay'), 10) || 0;
    var timer = null;

    function start() {
      if (!delay || reduced.matches || n < 2 || timer) return;
      timer = setInterval(function () { if (!document.hidden) go(index + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    /* --- dots --- */
    if (dotsWrap && n > 1) {
      for (var i = 0; i < n; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fh-car__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', slides[i].getAttribute('data-car-label') || ('Item ' + (i + 1)));
          b.addEventListener('click', function () { stop(); go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
    }

    if (n < 2) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); go(index + 1); });

    /* --- a swipe must not end in a navigation --- */
    for (var j = 0; j < n; j++) {
      var link = slides[j].querySelector('a');
      if (!link) continue;
      link.addEventListener('click', function (e) {
        if (dragged) e.preventDefault();
      });
    }

    /* --- keyboard --- */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stop(); go(index - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { stop(); go(index + 1); e.preventDefault(); }
    });

    /* --- drag and swipe ---
       No setPointerCapture: it retargets click to the capturing element
       and would break the links again. window handles move and up so a
       drag released outside the viewport still resolves. */
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; dragged = false; startX = e.clientX;
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - startX) > 6) dragged = true;
    });

    window.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 45) { stop(); go(index + (dx < 0 ? 1 : -1)); }
      /* Let the click that follows this pointerup see the flag, then
         clear it. */
      setTimeout(function () { dragged = false; }, 0);
    });

    window.addEventListener('pointercancel', function () { down = false; dragged = false; });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
    if (reduced.addEventListener) {
      reduced.addEventListener('change', function () { if (reduced.matches) stop(); });
    }

    layout();
    start();
  }

  function initAll() {
    var all = document.querySelectorAll('[data-hero-carousel]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', initAll);
})();
